import { GA4 } from 'react-ga4/types/ga4';

import { AppRoute } from '../../routes';
import { AnalyticsGTM, IAnalytics, IG4DefaultParams } from '../analytics-gtm';

import {
  ConverterAnalyticsEventType,
  ConverterPageType,
  IFileUploadParams,
  IImageDownloadParams,
} from './types';

class ConverterAnalytics extends AnalyticsGTM {
  constructor(options: IAnalytics, ga4Instance: GA4) {
    super(options, ga4Instance);
  }

  public landingPage() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.LANDING_PAGE,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalyticsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.HOME);
  }

  public previewPage() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.PREVIEW,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalyticsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.PREVIEW);
  }

  public resultsPage() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.RESULTS,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalyticsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.RESULTS);
  }

  public emptyPage() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.EMPTY,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalyticsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.EMPTY);
  }

  public errorPage() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name: ConverterPageType.ERROR,
      non_interaction: true,
    });
    this.hjEvent(ConverterAnalyticsEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.ERROR);
  }

  public fileUpload(params: IFileUploadParams) {
    this.sendGaEvent('file_upload', params);
    this.hjEvent('file_upload');
  }

  public fileDownload(params: IImageDownloadParams) {
    this.sendGaEvent('file_download', params);
    this.hjEvent('file_download');
  }

  public newFilesConvert(params: IG4DefaultParams, eventName: string) {
    this.sendGaEvent(eventName, params);
    this.hjEvent(eventName);
  }

  public filePreview(params: IG4DefaultParams) {
    this.sendGaEvent('file_preview', params);
    this.hjEvent('file_preview');
  }

  public fileDelete(params: IG4DefaultParams) {
    this.sendGaEvent('file_delete', params);
    this.hjEvent('file_delete');
  }
}

export default ConverterAnalytics;
